/**
 * A/B Test: Pre-select Value Pack (2)
 *
 * Control (A): select Single Pack — body[data-preselect-value-pack="false"]
 * Variant (B): select Value Pack (2) — body[data-preselect-value-pack="true"]
 *
 * Kaching defaults to Value Pack (2) ("Most Popular"), so control must
 * explicitly select Single Pack for the test to differ.
 *
 * IntelliGems sets the attribute on <body>.
 * Dev override: ?preselect_value_pack=a|b
 */
(function () {
  'use strict';

  if (window.__preselectValuePackABTestInit) return;
  window.__preselectValuePackABTestInit = true;

  var BODY_ATTR = 'data-preselect-value-pack';
  var CONTROL_LABEL = 'Single Pack';
  var VARIANT_LABEL = 'Value Pack (2)';
  var timer = null;
  var busy = false;
  var selecting = false;
  var appliedVariant = null;
  var userPicked = false;

  function getDevOverride() {
    try {
      return new URLSearchParams(window.location.search).get('preselect_value_pack');
    } catch (e) {
      return null;
    }
  }

  function getVariant() {
    var override = getDevOverride();
    if (override === 'b') return 'b';
    if (override === 'a') return 'a';

    var body = document.body;
    if (body && body.getAttribute(BODY_ATTR) === 'true') return 'b';
    return 'a';
  }

  function getTargetLabel(variant) {
    return variant === 'b' ? VARIANT_LABEL : CONTROL_LABEL;
  }

  function normalize(text) {
    return String(text || '').replace(/\s+/g, ' ').trim();
  }

  function getBarLabel(bar) {
    var title =
      bar.querySelector('.kaching-bundles__bar-title') ||
      bar.querySelector('[class*="bar-title"]') ||
      bar.querySelector('[class*="bar-name"]') ||
      bar.querySelector('label') ||
      null;

    return normalize(title ? title.textContent : bar.textContent);
  }

  function isBarHidden(bar) {
    if (!bar) return true;
    if (bar.getAttribute('aria-hidden') === 'true') return true;
    if (bar.style.display === 'none') return true;
    if (bar.getAttribute('data-selluxe-hidden-bundle')) return true;
    if (bar.getAttribute('data-hide-family-pack-ab-hidden')) return true;
    return false;
  }

  function isBarSelected(bar) {
    if (!bar) return false;

    if (
      bar.classList.contains('kaching-bundles__bar--selected') ||
      bar.getAttribute('aria-checked') === 'true'
    ) {
      return true;
    }

    var radio = bar.querySelector('input[type="radio"]');
    return !!(radio && radio.checked);
  }

  function findBarByLabel(label) {
    var bars = document.querySelectorAll('.kaching-bundles__bar');
    var i;
    var bar;

    for (i = 0; i < bars.length; i++) {
      bar = bars[i];
      if (isBarHidden(bar)) continue;
      if (getBarLabel(bar).indexOf(label) > -1) return bar;
    }

    return null;
  }

  function selectBar(bar) {
    if (!bar || isBarHidden(bar)) return false;

    selecting = true;

    try {
      var radio = bar.querySelector('input[type="radio"]');
      var clickable =
        bar.querySelector('.kaching-bundles__bar-container') ||
        bar.querySelector('[role="radio"]') ||
        bar;

      if (radio && !radio.disabled) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (clickable && typeof clickable.click === 'function') {
        clickable.click();
      }

      return isBarSelected(bar);
    } finally {
      selecting = false;
    }
  }

  function process() {
    if (busy) return;
    busy = true;

    try {
      if (userPicked) return;

      var variant = getVariant();
      var bar = findBarByLabel(getTargetLabel(variant));
      if (!bar) return;

      if (isBarSelected(bar)) {
        appliedVariant = variant;
        return;
      }

      if (selectBar(bar)) {
        appliedVariant = variant;
      }
    } finally {
      busy = false;
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(process, 50);
  }

  function onUserInteraction(event) {
    if (selecting) return;

    var bar = event.target && event.target.closest
      ? event.target.closest('.kaching-bundles__bar')
      : null;

    if (!bar) return;
    userPicked = true;
  }

  function watchBodyAttribute() {
    if (!document.body || !window.MutationObserver) return;

    new MutationObserver(function () {
      appliedVariant = null;
      userPicked = false;
      schedule();
    }).observe(document.body, {
      attributes: true,
      attributeFilter: [BODY_ATTR]
    });
  }

  function watchBundleInjection() {
    if (!document.body || !window.MutationObserver) return;

    new MutationObserver(function () {
      if (userPicked || selecting) return;
      if (appliedVariant === getVariant()) {
        var bar = findBarByLabel(getTargetLabel(appliedVariant));
        if (bar && isBarSelected(bar)) return;
      }
      schedule();
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    document.addEventListener('click', onUserInteraction, true);
    document.addEventListener('change', onUserInteraction, true);

    process();
    watchBodyAttribute();
    watchBundleInjection();

    setTimeout(process, 400);
    setTimeout(process, 1200);
    setTimeout(process, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', schedule);
})();
